import { RatingGroup } from '@chakra-ui/react';
import { Star } from 'lucide-react';
import * as React from 'react';

import {
  ratingDefaultColorPalette,
  ratingDefaultSize,
  type RatingSize,
} from './rating.kds';

export interface RatingProps extends Omit<RatingGroup.RootProps, 'size' | 'colorPalette'> {
  /** Custom star icon; defaults to Lucide `Star` with solid fill. */
  icon?: React.ReactElement;
  /** Total number of stars. Default `5`. */
  count?: number;
  /** Optional visible label above the control. Prefer external `Field` for form labels. */
  label?: React.ReactNode;
  /** KDS size — Chakra Rating sizes. Default `md` (~24px stars). */
  size?: RatingSize;
  /** Color palette for filled stars. Default `brand`. */
  colorPalette?: RatingGroup.RootProps['colorPalette'];
}

export const Rating = React.forwardRef<HTMLDivElement, RatingProps>(function Rating(props, ref) {
  const {
    icon = <Star fill="currentColor" />,
    count = 5,
    label,
    size = ratingDefaultSize,
    colorPalette = ratingDefaultColorPalette,
    ...rest
  } = props;

  return (
    <RatingGroup.Root ref={ref} count={count} size={size} colorPalette={colorPalette} {...rest}>
      {label != null && <RatingGroup.Label>{label}</RatingGroup.Label>}
      <RatingGroup.HiddenInput />
      <RatingGroup.Control>
        {Array.from({ length: count }).map((_, index) => (
          <RatingGroup.Item key={index} index={index + 1}>
            <RatingGroup.ItemIndicator icon={icon} />
          </RatingGroup.Item>
        ))}
      </RatingGroup.Control>
    </RatingGroup.Root>
  );
});
